<template>
  <slot></slot>
  <AudioPlayerModul
    ref="audio-player-modul"
    @collapse="showInformer = true"
    @hide="destroyedPlayer, (showInformer = false)"
  />
  <MiniAudioInformer
    :track="currentTrack"
    :progress="progress"
    :isPlaying="isPlaying"
    @togglePlayback="togglePlayback"
    @slidebarOpen="slidebarOpen"
    v-if="currentTrack && showInformer"
  />
</template>

<script lang="ts">
import { mixins, Options } from "vue-class-component";
import useAudioControl from "./useAudioControl";

import AudioPlayerModul from "@/components/audio/audio-player-modul.vue";
import MiniAudioInformer from "@/components/audio/mini-audio-informer.vue";

@Options({
  components: { AudioPlayerModul, MiniAudioInformer },
  emits: ["send-new-command"],
  watch: {
    currentTrack(newvalue, oldvalue) {
      if (!newvalue) {
        this.destroyedPlayer();
        return;
      }
      // Тот же трек (например, после перемешивания очереди) — не перезапускаем воспроизведение
      if (oldvalue && newvalue._id === oldvalue._id) return;
      this.playAudio();
    },
  },
})
class AudioPlayer extends mixins(useAudioControl) {
  showInformer = true;
  sideBarDisabled = true;

  $refs!: { "audio-player-modul": InstanceType<typeof AudioPlayerModul> };

  get progress(): number {
    if (!this.duration) return 0;
    return (this.currentTime / this.duration) * 100;
  }

  openNewTrack(step: 1 | -1): void {
    if (step === 1) this.nextTrack();
    else this.prevTrack();
  }

  togglePlayback(): void {
    if (this.isPlaying) this.pause();
    else this.play();
  }

  slidebarOpen(): void {
    if (this.sideBarDisabled) return;
    const slidebar = this.$refs["audio-player-modul"];
    if (slidebar) slidebar.openAudioOffcanvas();
  }

  playAudio(): void {
    if (!this.currentTrack) return;

    this.sideBarDisabled = false;
    this.showInformer = false;

    if (this.useAudio.autoplay) {
      this.openAudio();
    } else {
      this.useAudio.setAutoplay(true);
      this.prepareAudio();
    }
  }
}
export default AudioPlayer;
</script>

<style lang="scss" scoped></style>
